<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('入金')}}</div>
		<div><router-link to="/my/rechargeRecord" style="color:#fff;">{{$t('充值记录')}}</router-link></div>
	</header>
	<div class="z-body recharge-body" :style="{bottom:'0px',height:(windowHeight-48)+'px'}">
		<div class="z-flex recharge-row bgw">
			<div>{{$t('币种')}}</div>
			<div style="padding: 10px 0;">
				<v-radio-group v-model="currency" dark row>
			      <v-radio label="USDT-TRC20" value="usdt-trc20"></v-radio>
            <v-radio label="USDT-ERC20" value="usdt-erc20"></v-radio>
			      <v-radio label="BTC" value="btc"></v-radio>
			  </v-radio-group>
			</div>
		</div>
    <div v-if="currency=='usdt-trc20'" class="z-flex bgw" style="flex-direction:column;border-bottom:1px solid #F5F5F5;">
    	<div style="padding:15px 0;">{{data.usdt.chain}}：</div>
    	<div><img :src="data.usdt.qrcode" style="width:100px;height:100px;"></div>
    	<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doSaveImg(data.usdt.qrcode)">{{$t('存为图片')}}</div>
    </div>
    <div v-if="currency=='usdt-trc20'" class="z-flex bgw" style="flex-direction:column;border-bottom:1px solid #F5F5F5;">
    	<div style="padding:15px 0;white-space:normal;text-align: justify;text-justify: newspaper;word-break: break-all;" v-text="data.usdt.code"></div>
    	<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doCopy(data.usdt.code)">{{$t('复制')}}</div>
    </div>

    <div v-if="currency=='usdt-erc20'" class="z-flex bgw" style="flex-direction:column;border-bottom:1px solid #F5F5F5;">
    	<div style="padding:15px 0;">{{data.usdt_erc20.chain}}：</div>
    	<div><img :src="data.usdt_erc20.qrcode" style="width:100px;height:100px;"></div>
    	<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doSaveImg(data.usdt_erc20.qrcode)">{{$t('存为图片')}}</div>
    </div>
    <div v-if="currency=='usdt-erc20'" class="z-flex bgw" style="flex-direction:column;border-bottom:1px solid #F5F5F5;">
    	<div style="padding:15px 0;white-space:normal;text-align: justify;text-justify: newspaper;word-break: break-all;" v-text="data.usdt_erc20.code"></div>
    	<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doCopy(data.usdt_erc20.code)">{{$t('复制')}}</div>
    </div>

		<div v-if="currency=='btc'" class="z-flex bgw" style="flex-direction:column;border-bottom:1px solid #F5F5F5;">
			<div style="padding:15px 0;">{{data.btc.chain}}：</div>
			<div><img :src="data.btc.qrcode" style="width:100px;height:100px;"></div>
			<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doSaveImg(data.btc.qrcode)">{{$t('存为图片')}}</div>
		</div>
		<div v-if="currency=='btc'" class="z-flex bgw" style="flex-direction:column;border-bottom:1px solid #F5F5F5;">
			<div style="padding:15px 0;" v-text="data.btc.code"></div>
			<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doCopy(data.btc.code)">{{$t('复制')}}</div>
		</div>

		<div class="z-flex recharge-row bgw">
			<div>{{$t('充值金额')}}</div>
			<div style="height: 40px;width:80%;border-bottom:1px solid #dfb15f;">
				<input type="number" style="height: 100%;width:100%;" :placeholder="amount_before+amount_after" v-model="money">
			</div>
		</div>
		<div class="z-flex recharge-row bgw" style="padding: 50px 10px;">
			<div>{{$t('凭证')}}</div>
			<div style="margin-right:20px;position:relative;">
			  <img style="height:80px;width:auto;" :src="pingzheng">
			  <input type="file" @change="handleFile($event)" style="position:absolute;width: 60px;height: 60px;left:0;right:0;top:0;bottom:0;z-index:999;opacity:0;">
			</div>
		</div>
		<section style="text-align: center">
			<div @click="doPost"  class="common-btn">{{$t('提交')}}</div>
		</section>
		<!-- <div class="recharge-tips">
			<p style="color:#FA5E00;">重要提示</p>
			<div v-html="data.desc" style="margin-bottom: 80px;"></div>
		</div> -->
	</div>
</div>
</template>
<script>
export default {
	name: 'recharge',
	data() {
		return {
			currency:'usdt-trc20',
			data:{},
			pingzheng:require('../../assets/my/upload.png'),
			money:'',
			pic:0,
		}
	},
	mounted() {
		this.doInit()
	},
	created() {

	},
	methods: {
		doInit:function () {
			this.get('api/account/inComeConf', {}).then((res) => {
				if (res.code == 0) {
					this.data = res.data
				}
			})
		},
		doPost:function () {
			this.post('/api/account/inCome', {money:this.money,pic:this.pic,currency:this.currency}).then((res) => {
				this.$store.commit('layer',res.msg)
				if (res.code == 0) {
					this.jump('/my')
				}
			})
		},
		doSaveImg:function (url) {
			let a = document.createElement('a');
              a.download = this.$t('链地址')
              a.href = url;
              a.click();
		},
		doCopy:function(value){
			let _input = document.createElement("input");   // 直接构建input
			_input.value = value;  // 设置内容
			document.body.appendChild(_input);    // 添加临时实例
			_input.select();   // 选择实例内容
			document.execCommand("Copy");   // 执行复制
			document.body.removeChild(_input); // 删除临时实例
            this.$store.commit('layer',this.$t('成功'))
		},
		//凭证上传
		  handleFile: function(event) {
			event.preventDefault();
			var _this = this;
			let file = event.target.files[0];
			// 看支持不支持FileReader
			if (!file || !window.FileReader) return;
			if (/^image/.test(file.type)) {
			  // 创建一个reader
			  let reader = new FileReader();
			  // 将图片将转成 base64 格式
			  reader.readAsDataURL(file);
			  // 读取成功后的回调
			  reader.onloadend = function() {
				_this.pingzheng = this.result;
			  }
			}
			var formData = new FormData();
			formData.append('file', file);
			formData.append('token', _this.getToken());
			_this.upload('api/member/upFile.html', formData).then((res) => {
			  if (res.code == 0) {
				_this.pic = res.data
			  } else {
				_this.$store.commit('layer', res.msg)
			  }
			})
		  },
	}
}
</script>
<style scoped>
.bgw{
	color: #FFF;
}
.recharge-tips {
	font-size: 16px;
	padding: 10px;
}
.recharge-tips p{
	margin-bottom: 10px;
}
.recharge-row {
	justify-content:space-between;
	border-bottom: 1px solid #F5F5F5;
	padding:0 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/recharge.vue